import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { progressPointsColumns } from "./ProgressPoints.columns";
import { progressPointsRows } from "./ProgressPoints.data";

const ProgressPointsTable = () => {
  return (
    <DefaultDataGrid
      loading={false}
      rows={progressPointsRows}
      columns={progressPointsColumns}
      getRowHeight={() => "auto"}
      disableRowSelectionOnClick
      disableCellFocus
      hideFooter
      sx={{
        "& .MuiDataGrid-cell": {
          alignItems: "flex-start",
          py: 1,
        },
      }}
    />
  );
};

export default ProgressPointsTable;
